import React from "react";

export const numberFormat = (number) => {
  if (number === undefined || number === null || number === '') {
    return number
  }

  // Bulatkan ke atas jika ada desimal
  const roundedNumber = Math.ceil(number)

  const string = roundedNumber.toString()
  const left = string.length % 3
  let rupiah = string.substring(0, left)
  const thousand = string.substring(left).match(/\d{3}/g)

  if (thousand) {
    const separate = left ? '.' : '';
    rupiah += separate + thousand.join('.')
  }
  return rupiah
}